import { utils } from "vincent-utils";
const comparePatientsCandidats = function (patientA, patientB, hint) {
    const nomA = patientA.name.toLowerCase();
    const nomB = patientB.name.toLowerCase();
    const prenomA = (patientA.forename && patientA.forename.toLowerCase()) || "";
    const prenomB = (patientB.forename && patientB.forename.toLowerCase()) || "";
    if (hint) {
        if (nomA === hint && nomB !== hint) {
            return -1;
        }
        if (nomB === hint && nomA !== hint) {
            return 1;
        }
        if (nomA.indexOf(hint) === 0 &&
            nomA[hint.length] === " " &&
            nomB.indexOf(hint) === 0 &&
            nomB[hint.length] === " ") {
            return utils.frenchSort(nomA + prenomA, nomB + prenomB);
        }
        if (nomA.indexOf(hint) === 0 && nomA[hint.length] === " ") {
            return -1;
        }
        if (nomB.indexOf(hint) === 0 && nomB[hint.length] === " ") {
            return 1;
        }
        if (nomA.indexOf(hint) === 0 && nomB.indexOf(hint) === 0) {
            return utils.frenchSort(nomA + prenomA, nomB + prenomB);
        }
        if (nomA.indexOf(hint) === 0) {
            return -1;
        }
        if (nomB.indexOf(hint) === 0) {
            return 1;
        }
    }
    return utils.frenchSort(nomA + prenomA, nomB + prenomB);
};
const curriedSpecialSort = function (hint) {
    return function (a, b) {
        return comparePatientsCandidats(a, b, hint);
    };
};
export { comparePatientsCandidats, curriedSpecialSort };
//# sourceMappingURL=sorters.js.map